import Webcam, { WebcamProps } from "react-webcam";
import VideoModal from "../VideoModal"
import CrossIconWhite from "../../assets/images/CrossIconWhite.png";


const videoConstraints: WebcamProps["videoConstraints"] = {
    width:3000,
    height: 3000,
    facingMode:'user',
};

const audioConstraints :  WebcamProps["audioConstraints"]= {
  noiseSuppression: true,
  echoCancellation: true,
};

interface WebcamComponentPropTypes{
  showWebcamModal:boolean;
  onCloseWebcam:()=>void;
  webcamRef:any;
  recordingVideo:boolean;
  onCloseCamera:()=>void;
  handleStartRecording:()=>void;
  handleStopRecording:()=>void;
}


const WebcamComponent: React.FC<WebcamComponentPropTypes> = ({
  showWebcamModal,
  onCloseWebcam,
  webcamRef,
  recordingVideo,
  onCloseCamera,
  handleStartRecording,
  handleStopRecording,
}) => {
  
  return(
        <VideoModal isVisible={showWebcamModal}  
        onClose={()=>{
    onCloseWebcam()
      }}>
         <div >
        <Webcam
   imageSmoothing={true}
   ref={webcamRef}
   mirrored={true}
   audio={true}
   muted={true}
   videoConstraints={videoConstraints}
   audioConstraints={audioConstraints}
   style = {{width: "100%", height: "110%", position: "absolute", left: "50%", marginLeft: "-50%", objectFit: "contain",
    objectPosition: "center"}}
   />
   <div onClick={()=>{ 
     onCloseWebcam()
       }} style={{position:'absolute',right:10,top:10,cursor:'pointer'}}>
   <img src={CrossIconWhite} style={{width:'30px',height:'30px'}}/>
   </div>
   {!recordingVideo && <button className="videoComponentBtnStyle" onClick={handleStartRecording}>Start Recording</button>}
   {recordingVideo &&<button className="videoComponentBtnStyle"  onClick={()=>{
             onCloseCamera()
             handleStopRecording()}} >Stop Recording</button>}
     
   </div>
   
        </VideoModal>
    )
}

export default WebcamComponent